/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         23/04/24 - 14:04:02
 * Module name:  toast-config.constant
 * File name:    toast-config.constant.ts
 * IDE:          WebStorm
 */
import {ZbStatusType} from '@zibanu/ui';

export const getToastConfig = (severity: ZbStatusType, icon: string, cssClass: string | undefined, duration: number) => {
  return {
    status: severity,
    icon: {
      icon: icon,
      pack: 'eva',
    },
    toastClass: cssClass,
    duration: duration,
  };
};
